<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card
            :class="cardClass"
            color="grey darken-2"
            max-width="600"
            @click="cardClicked"
    >
        <v-tooltip top color="primary">
            <template v-slot:activator="{ on }">

                <v-sheet
                        v-on="on"
                        class="v-sheet--offset mx-auto"
                        :color="color"
                        elevation="12"
                        max-width="calc(100% - 80px)"
                >
                    <v-sparkline
                            :labels="sparkLineLabels"
                            :value="sparkLineValues"
                            color="white"
                            line-width="1"
                            padding="16"
                            smooth
                            auto-draw
                            height="80"
                            label-size="10"
                    ></v-sparkline>

                </v-sheet>
            </template>
            <span>
                This chart displays panel utilization variations in the past 15 weeks
            </span>
        </v-tooltip>

        <v-card-text class="pt-0 pb-0">
            <v-container class="pa-0">
                <v-row dense>

                    <!-- UTILIZATION -->
                    <v-col cols="12">
                        <utilization-label :value="metrics.invitedPercent"
                                           :count="metrics.invitedCount"
                                           title="Panel utilization"
                                           sub-title="% of panelists invited to projects"
                                           postfix="%"
                        ></utilization-label>
                    </v-col>

                    <!-- OPENED -->
                    <v-col cols="12">
                        <utilization-label :value="metrics.openedPercent"
                                           :count="metrics.openedCount"
                                           title="Opened"
                                           sub-title="% of panelists reading project invites"
                                           postfix="%"
                        ></utilization-label>
                    </v-col>

                    <!-- STARTED -->
                    <v-col cols="12">
                        <utilization-label :value="metrics.startedPercent"
                                           :count="metrics.startedCount"
                                           title="Started"
                                           sub-title="% of panelists starting projects"
                                           postfix="%"
                        ></utilization-label>
                    </v-col>

                    <!-- COMPLETED -->
                    <v-col cols="12">
                        <utilization-label :value="metrics.completedPercent"
                                           :count="metrics.completedCount"
                                           title="Completed"
                                           sub-title="% of panelists completing projects"
                                           postfix="%"
                        ></utilization-label>
                    </v-col>

                    <!-- TERMINATED -->
                    <v-col cols="12">
                        <utilization-label title="Disqualified"
                                           sub-title="% of panelists disqualified for quota or profile"
                                           :value="metrics.disqualifiedPercent"
                                           :count="metrics.disqualifiedCount"
                                           postfix="%"
                                           progress-color="red lighten-1"
                        ></utilization-label>
                    </v-col>

                    <!-- DISQUALIFIED -->
                    <v-col cols="12" v-show="metrics.terminatedCount > 0">
                        <utilization-label title="Terminated"
                                           sub-title="% of panelists terminated for quality, duplicate or security"
                                           :value="metrics.terminatedPercent"
                                           :count="metrics.terminatedCount"
                                           postfix="%"
                                           progress-color="red lighten-1"
                        ></utilization-label>
                    </v-col>

                    <!-- REPORT PERIOD SELECTION -->
                    <v-col cols="12" v-if="hint" class="pt-1 pb-2">

                        <v-select class="periodSelector body-2"
                                  style="opacity: 0.5;"
                                  v-model="periodModel"
                                  background-color="grey darken-2"
                                  dense
                                  flat
                                  solo
                                  hide-details
                                  item-text="name"
                                  item-value="value"
                                  :items="periods"
                        ></v-select>

                    </v-col>

                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>

    import UtilizationLabel from "./UtilizationLabel";
    import FooterNote from "../../../components/UI/FooterNote";


    export default {

        components: {
            UtilizationLabel,
            FooterNote
        },

        props: {

            metrics: {
                type: Object,
                required: true,
            },
            height: {
                type: Number,
                required: false,
                default: 100
            },
            color: {
                type: String,
                required: false,
                default: 'primary'
            },
            loading: {
                type: Boolean,
                required: false,
                default: false,
            },
            sparkLabels: {
                type: Array,
                required: false,
                default: () => null,
            },
            sparkValues: {
                type: Array,
                required: false,
                default: () => null
            },
            clickable: {
                type: Boolean,
                required: false,
                default: false,
            },
            hint: {
                type: String,
                required: false,
            },
            period: {
                type: Number,
                required: false,
                default: 12
            }
        },

        data() {
            return {
                periods: [
                    {name: 'Report period past month', value: 1},
                    {name: 'Report period past 3 months', value: 3},
                    {name: 'Report period past 6 months', value: 6},
                    {name: 'Report period past 12 months', value: 12},
                ]
            }
        },

        computed: {

            periodModel: {
                get() {
                    return this.period;
                },
                set(value) {
                    if (value !== this.period) {
                        this.$emit('change', value);
                    }
                }
            },

            cardClass() {
                let style = 'ma-2 mt-5';
                if (!this.clickable) style += ' cursor-override';
                return style;
            },

            boxValue() {
                return this.value;
            },

            sparkLineValues() {
                if (this.sparkValues) return this.sparkValues;
                return [0, 0];
            },

            sparkLineLabels() {
                if (this.sparkLabels) return this.sparkLabels;
                return [' ', ' '];
            }
        },

        methods: {
            cardClicked() {
                if (this.clickable) {
                    this.$emit('click');
                }
            },
        }

    }
</script>

<style scoped>

    .cursor-override {
        cursor: default !important
    }

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }
</style>
